import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Clock, BookOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const rejected = user?.status === "rejected";
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-page px-6 text-center grain">
      <div className="relative z-10 max-w-md fade-up">
        <div className="flex items-center justify-center gap-2 mb-8">
          <BookOpen className="text-terra" size={26} />
          <span className="font-serif text-3xl text-ink">AktifOkur</span>
        </div>
        <div className="w-16 h-16 rounded-full bg-gold/15 flex items-center justify-center mx-auto">
          <Clock className="text-gold" size={30} />
        </div>
        <h1 className="font-serif text-3xl text-ink mt-6" data-testid="pending-title">
          {rejected ? "Başvurun onaylanmadı" : "Hesabın onay bekliyor"}
        </h1>
        <p className="text-ink-2 mt-3 leading-relaxed">
          {rejected
            ? "Üyelik başvurun şu an için uygun bulunmadı. Sorunuz varsa topluluk yöneticisiyle iletişime geçebilirsiniz."
            : "Merhaba " + (user?.ad_soyad || "") + ", topluluğumuz kapalı devredir. Bir admin hesabını onayladığında tüm özelliklere erişebileceksin."}
        </p>
        <Button onClick={async () => { await logout(); navigate("/giris"); }} data-testid="pending-logout"
          className="mt-8 bg-terra hover:bg-terra-hover text-white rounded-full px-6 h-11">Çıkış Yap</Button>
      </div>
    </div>
  );
}
